/** A sheet row's number, shown as a small boxed cell (Excel's row-number
 *  gutter) instead of plain "Row N" text — lets the admin visually track
 *  which sheet row a card corresponds to across tabs. */
export function RowNumberBadge({ n }: { n: number }) {
  return (
    <span className="inline-flex h-5 min-w-5 shrink-0 items-center justify-center rounded-sm border border-border bg-muted px-1 font-mono text-[10px] font-medium text-muted-foreground">
      <span className="sr-only">Row </span>
      {n}
    </span>
  );
}
